import { Download, Hash, Share2, CreditCard, Wallet } from "lucide-react";
import { FadeIn, Eyebrow } from "./Reveal";

const STEPS = [
  {
    num: "01",
    title: "Install EduAlert App",
    desc: "Create your account",
    icon: Download,
  },
  {
    num: "02",
    title: "Get Your Referral Code",
    desc: "Your unique code is available in the app",
    icon: Hash,
  },
  {
    num: "03",
    title: "Share With Your Network",
    desc: "Use our ready-made creatives and videos from the Telegram/WhatsApp channel to share with your students",
    icon: Share2,
  },
  {
    num: "04",
    title: "Student Buys Premium (₹599)",
    desc: "They enter your referral code on the payment screen",
    icon: CreditCard,
  },
  {
    num: "05",
    title: "You Earn ₹150, They Get ₹50",
    desc: "Automatically credited to wallets",
    icon: Wallet,
    accent: true,
  },
];

export default function HowItWorksSection() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="border-y border-[#e2e8f0] bg-[#f8fafc] py-16 sm:py-24 lg:py-32"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <FadeIn>
                <Eyebrow index="02" label="How It Works" />
                <h2 className="font-display mt-4 text-3xl font-black tracking-tight text-[#1a237e] sm:text-4xl lg:text-5xl">
                  How It Works?
                </h2>
                <p className="mt-4 max-w-md text-lg leading-relaxed text-slate-600">
                  Get started in just 5 simple steps
                </p>
              </FadeIn>
            </div>

            <div className="grid gap-10 sm:gap-0 sm:divide-y sm:divide-[#e2e8f0] lg:hidden">
              {STEPS.map((step) => (
                <FadeIn key={step.num} className="py-6 sm:py-7">
                  <StepRow step={step} />
                </FadeIn>
              ))}
            </div>
          </div>

          <div className="hidden lg:col-span-7 lg:block">
            <div className="divide-y divide-[#e2e8f0]">
              {STEPS.map((step, i) => (
                <FadeIn key={step.num} delay={i * 0.06} className="py-7">
                  <StepRow step={step} />
                </FadeIn>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function StepRow({ step }) {
  const Icon = step.icon;
  return (
    <div className="group flex items-start gap-5 sm:gap-7">
      <span
        className={`font-display shrink-0 text-4xl font-black leading-none sm:text-5xl ${
          step.accent ? "text-[#f57c00]" : "text-[#c5cae9]"
        } transition-colors duration-300 group-hover:text-[#f57c00]`}
        data-testid={`step-number-${step.num}`}
      >
        {step.num}
      </span>
      <div className="min-w-0 flex-1">
        <h3 className="font-display text-lg font-extrabold text-[#1a237e] sm:text-xl">
          {step.title}
        </h3>
        <p className="mt-1.5 text-sm leading-relaxed text-slate-600 sm:text-base">
          {step.desc}
        </p>
      </div>
      <span
        className={`hidden h-12 w-12 shrink-0 items-center justify-center rounded-2xl sm:flex ${
          step.accent
            ? "bg-[#f57c00] text-white"
            : "bg-[#e8eaf6] text-[#1a237e]"
        } transition-transform duration-300 group-hover:-rotate-6 group-hover:scale-105`}
      >
        <Icon className="h-5 w-5" />
      </span>
    </div>
  );
}